export default "__VITE_ASSET__5ff58c16__"